import React from 'react';
import { EcwOrder, EcwOrdersResponse } from '../EcwConstants';

interface EcwOrderInfoProps {
    ecwOrderList: EcwOrdersResponse;
    selectedOrderInfo: EcwOrder | null | undefined;
}

const EcwOrderInfo: React.FC<EcwOrderInfoProps> = ({ ecwOrderList, selectedOrderInfo }) => {
    if (ecwOrderList && selectedOrderInfo) {
        return (
            <div className='order-info-wrapper'>
                <div className='order-info-box'>
                    <div>
                        <span>Patient</span>
                        <p><b>{ecwOrderList?.lastName}, {ecwOrderList?.firstName}</b> {ecwOrderList?.gender} ({ecwOrderList?.birthDate})</p>
                    </div>
                    <div>
                        <span>Item</span>
                        <p><b>{selectedOrderInfo?.vaccineName}</b></p>
                    </div>
                    <div>
                        <span>Provider</span>
                        <p>{selectedOrderInfo?.provider?.lastName} {selectedOrderInfo?.provider?.firstName} ({selectedOrderInfo?.provider?.npi})</p>
                    </div>
                    <div>
                        <span>User</span>
                        <p>{selectedOrderInfo?.loggedUser?.lastName} {selectedOrderInfo?.loggedUser?.firstName}</p>
                    </div>
                    <div>
                        <span>Encounter</span>
                        <p>{selectedOrderInfo?.encounterId} ({selectedOrderInfo?.encounterDate})</p>
                    </div>
                    <div>
                        <span>Location</span>
                        <p>{selectedOrderInfo?.facility?.facilityName} ({selectedOrderInfo?.facility?.facilityId})</p>
                    </div>
                    <div>
                        <span>Order</span>
                        <p>{selectedOrderInfo?.immId} ({selectedOrderInfo?.status})</p>
                    </div>
                    <div>
                        <span>CVX</span>
                        <p>{selectedOrderInfo?.cvxCode}</p>
                    </div>
                </div>
                <div className="order-status-box">
                    <span>Processed <i className='status-square' title={selectedOrderInfo?.isSuccess === false ? (selectedOrderInfo?.ecwResponseMessage ?? '') : ''} style={{ backgroundColor: selectedOrderInfo?.colour || 'gray' }}></i></span>
                </div>
            </div>
        )
    }

    return null;
}

export default EcwOrderInfo;
